export enum TagClassEnum {
  AppManager = 145,
  WidgetManager = 146,
  ComponentManager = 46,
  Reports = 14,
  Trend = 147,
  ElementTemplate = 16, //Nibras.Core.DataTemplate.ElementTemplate
  Hierarchy = 130, //Hierarchy,
  SecurityRole = 140, //Nibras.Core.Security.Role
  ProcessTags = 153
}

export enum ValueType {
  Integer = 12,
  //Empty = 0,
  Object = 1,
  DBNull = 2,
  Boolean = 3,
  Char = 4,
  SByte = 5,
  Byte = 6,
  Int16 = 7,
  UInt16 = 8,
  Int32 = 9,
  UInt32 = 10,
  Int64 = 11,
  UInt64 = 12,
  Single = 13,
  Double = 14,
  Decimal = 15,
  DateTime = 16,
  GUID = 17,
  String = 18,
  ChartType = 27,
  Element = 28,
  ElementTemplate = 29,
  AttributeTemplate = 30,
  Attribute = 31,
  SeriesColor = 33,
  Color = 33,
  RelativeDateTime = 34,
  XAxis = 35,
  YAxis = 36,
  // DataLoading = 36,
  ElementType = 37,
  AggregateDataMethods = 38,
  Role = 39,
  TextArea = 40,
  UOM = 43, //UOM as attribute in INPUT_PARAM_ATTRIBUTE - VJ 12.11.2018
  TaggingDirection = 44,
  ProcessType = 45,
  ProcessPriority = 46,
  ProcessTrigger = 47,
  IntegerArray = 48,
  StringArray = 49,
  DoubleArray = 50,
  DoubleIntArray = 51,
  DateTimeFrequency = 52,
  DataTransmissionMode = 53,
  ConditionalFormatting = 54,
  FileCategory = 55,
  XaxisPosition = 59,
  YaxisPosition = 60,
  DataMethods = 61,
  ConfigDataMethods = 62,
  ChartSymbol = 63,
  ChartMarkPoint = 64,
  ColumnWidthStyle = 65,
  PivotAggregates = 66,
  PivotChartDataType = 67,
  XYPlotType = 68,
  Json = 69,
  Icon = 70,
  PivotChartType = 71,
  Process = 72,
  SAPFunctionalLocation = 73,
  DateTimeOptions = 73,
  SAPConsequenceCategory = 74,
  QueryOperation = 74,
  ProcessCategory = 75,
  TextEntryTypes = 76,
  ConfigDropDownValues = 77,
  FormulaExpression = 78,
  MetaDataLabels = 81,
  DateFormat = 90,
  ProcessViewerStatus = 91,
  Apps = 92,
  SLACompliance = 94,
  LimitSettingsView = 95,
  TextOrientation = 96,
  TableType = 97,
  SortType = 98,
  Frequency = 99,

  //100 series
  dcDateFormat = 100,
  //LineType = 101,
  ChartLineType = 101, //Coresponding Class is Nibras.Common.LineType
  RichTextArea = 102,
  ElementSelectorOption = 103,
  Event = 104,
  SwitchToLatestData = 105,
  ShowInColumnGroup = 106,
  RowEditPin = 111,

  //200 series
  SummaryOptions = 201,
  dcTag = 203,
  dcTagMap = 204,
  Alignment = 205,
  PrintCommands = 210,
  ReportType = 213,
  ReportGroupType = 214,
  RetrievalMode = 218,
  DigitalStateDisplay = 219,
  RetentionType = 220,

  //300 series
  SupportedTemplate = 300,
  Filter = 301,
  Owner = 302,
  Custodian = 303,
  LinkApp = 304,
  ChildSupportedTemplate = 305,
  PowerBIType = 306,
  File = 307,
  MoreInfo = 308,
  DataFrequency = 310,
  GeoAnalyticsChartType = 320,
  SchematicColumns = 321,
  PdfOrientation = 109,
  PdfFormat = 110,
  ReportNavigationMode = 325,
  GenericDropdown = 326,
  ActionType = 327,
  Roles = 328,
  CurrentUser = 329,
  CurrentDateTime = 330,
  Tag = 331,
  ComboBox = 332,
  AnalysisDefaultMode = 333,
  SankeyFlowOrderBy = 1010
}

export enum MetaDataLabels {
  RootElementName = 1,
  ElementName = 2,
  RootElementTemplateName = 4,
  ElementPath = 8,
  AttributePath = 16,
  ElementTypeID = 32,
  RootElementVersionID = 64,
  ElementVersionID = 128,
  AttributeID = 256,
  Value = 512,
  ValueTime = 1024,
  IsGood = 2048,
  MessageString = 4096,
  QueryInfo = 8192
}

export enum ActionTypeEnum {
  Add = 1,
  Edit = 2,
  Delete = 4,
  ViewDetail = 5,
  CreateTask = 6,
  SetCustomAttribute = 7
}

export enum AppTypeEnum {
  General = 1,
  FormBuilder = 2,
  WorkflowBuilder = 3
}

export enum AttributePermissions {
  Write,
  ReadOnly,
  Hidden
}

export enum dcSecurityRights {
  None = 0,
  // eslint-disable-next-line no-bitwise
  Read = 1 << 1,
  // eslint-disable-next-line no-bitwise
  Write = 1 << 2,
  // eslint-disable-next-line no-bitwise
  Delete = 1 << 4,
  // eslint-disable-next-line no-bitwise
  Execute = 1 << 8,
  // eslint-disable-next-line no-bitwise
  Admin = 1 << 16,
  // eslint-disable-next-line no-bitwise
  ReadData = 1 << 32,
  // eslint-disable-next-line no-bitwise
  WriteData = 1 << 64,
  // eslint-disable-next-line no-bitwise
  Subscribe = 1 << 128,
  // eslint-disable-next-line no-bitwise
  SubscribeOthers = 1 << 256,
  // eslint-disable-next-line no-bitwise
  Annotate = 1 << 512,
  // eslint-disable-next-line no-bitwise
  All = 1 << 65535
}

export enum dcAttributeTrait {
  None,
  LimitMinimum,
  LimitLoLo,
  LimitLo,
  LimitTarget,
  LimitHi,
  LimitHiHi,
  LimitMaximum,
  Forecast,
  AnalysisStartTriggerName,
  AnalysisStartTriggerExpression,
  LocationLatitude,
  LocationLongitude,
  LocationAltitude
}

/// <summary>
/// QueryParameterTypes Enumeration.
/// </summary>
export enum QueryParameterTypes {
  /// <summary>
  /// Parameters required to execute query requested.
  /// </summary>
  IN = 0,

  /// <summary>
  /// Query output type..
  /// </summary>
  OUT = 1,

  /// <summary>
  /// Query to execute(Pi Query/SP Query/Inline Query).
  /// </summary>
  INTERNAL = 3,

  /// <summary>
  /// Parameters which gets passed from client(front end) to Query.
  /// </summary>
  EXTERNAL = 4
}

export enum QueryManagerType {
  PrivateWithName = 0,
  Private = 1,
  Shared = 2,
  System = 3
}

//IMP: Please add any new BaseElementType in ascending order of their value.
export enum BaseElementType {
  //Empty = -1,
  //Process = 154,
  //WELL = 155,
  //Model = 1,
  //Transfer = 2,
  //Notification = 3,
  //Case = 4,
  //EventFrame = 5,
  //Element = 45,
  //Elements = 46,
  //ElementTemplate = 47,
  //App = 2005,
  //Widget = 2011,
  // Component = 8,
  //ReportColumn = 151,
  // TextBoxComponent = 268,
  //User = 141,
  //Role = 140,
  //Position = 14,
  //Profile = 15,
  //Hierarchy = 187,
  WorkflowDesignerComponent = 152,
  WorkflowSideToolBarComponent = 153,
  // AttributeBuilderComponent = 155,
  ProcessApprovalComponent = 240,
  EbsTrendComponent = 252,
  AcceptProcessComponent = 264,
  RuleExplorerComponent = 277,
  ConfigurationComponent = 299,

  NFExplorerComponent = 2068,
  AppStoreComponent = 2069,
  Report = 2086,

  DxManagerComponent = 2070,
  Trend = 2112,
  TrendAxis = 2113,
  ControlGroup = 2114,
  TrendSeries = 2115,
  Trend_XAXIS = 2183,
  Trend_YAXIS = 2184,
  XAxisContainer = 6008,
  YAxisContainer = 6009,
  TrendAxisStripLine = 6010, // Not included trend rule, right now static rule only.
  Trend_XAXIS_TIME = 2143,
  Trend_XAXIS_NONTIME = 2144,
  Trend_YAXIS_NUMERIC = 2145,
  Trend_YAXIS_NONNUMERIC = 2146,
  //ReportConfigComponent = 999999999999, //TODO: update this id,
  ParametersBuilderComponent = 2139,
  TransitionBuilderComponent = 2138,
  ProcessBuilderComponent = 2081,
  FormBuilderComponent = 2053,
  ProcessViewerComponent = 2141,
  NFExplorerTagWidgetComponent = 2012,
  //TemplateExplorerComponent = 2012,
  DeployProcessComponent = 2140,
  //Component = 258,
  //SidebarComponent = 259,
  //SidebarWidget = 262,
  TextboxComponent = 2109,
  //++Parvathi Changed from 2111 to 2209 to match new TimelineComponent
  TimeLineComponent = 2209,
  TimelineContent = 2211,
  TimelineStartDate = 2212,
  TimelineEndDate = 2213,
  TimelineCGLabel = 2223,
  TimelineComment = 2225,
  TimelineStatus = 2226,
  EBSAnalysisComponent = 2224,
  //--Parvathi end for timeline chart component changes
  LimitDiagramComponent = 2214,
  //++ For Andon Board
  KPIAndonBoardComponent = 2216,
  AndonHighlevelDataInput = 2219,
  AndonHighlevelGroupByInput = 2220,
  AndonSubProcessDataInput = 2221,
  AndonSubProcessGroupByInput = 2222,
  AndonBoardComponent = 2232,

  CustomTableComponent = 2670,
  //BT_BASE_ELEMENT = 490,
  //BT_WELL = 491,
  //RULE_HIERARCHY = 296,
  //WELL_GAS_LIFT = 912,
  TaskViewerComponent = 2105,
  KPIComplianceViewerComponent = 2106,
  VisualManagementDigitalizationComponent = 2107,
  //TrendConfigurationComponent = 298,
  FormulaParserComponent = 2136,
  HierarchyImportComponent = 2142,
  TextboxCollection = 2108,
  TextboxGroup = 2110,
  CasingHeadPressure = 2024,
  ScheduleDesignComponent = 2149,
  Query = 2000,
  Adapter = 2001,
  ScheduleBuilderComponent = 2151,
  ViolinPlot = 2147,
  ViolinPlotSeries = 2150,
  HierarchyBuilder = 2182,
  SankeyChart = 2148,
  SankeyChartGroups = 2152,
  SankeyChartFlow = 2153,
  LimitsSetings = 2196,
  Rule = 2017,
  RuleNode = 2128,
  KPIConfiguration = 2190,
  FileUploadComponent = 2191,

  GisComponent = 2192,
  UrlComponent = 2193,

  TREND_XY = 2198,
  TrendSeriesXY = 2199,
  TrendSeriesX = 2200,
  TrendSeriesY = 2201,
  TrendSeriesXYIndex = 2202,
  TrendSeriesXYTimestamp = 2203,
  TrendSeriesXConstant = 2204,
  TrendSeriesYConstant = 2205,
  TrendSeriesTrendLine = 2207,

  Toggle = 2665,
  WaterfallAppComponent = 2208,
  SOPElementType = 2096,
  ArrayEntry = 2666,
  JsonTable = 2668,
  WellTestValidation = 2210,

  PieComponent = 2215,
  TableColumn = 2125,
  GroupByControlGroup = 2217,
  AnnotationControlGroup = 2230,
  TooltipControlGroup = 6530,
  ComponentHeaderControlGroup = 6531,
  ComplianceReportComponent = 2231,
  TaskPlannerComponent = 2218,
  ComponentSecurityManagement = 2206,
  WellTest = 2189,

  //AttributeViewerComponent = 5033,
  AttributeViewer = 3032,
  AttributeViewerGroup = 3031,
  AttributeViewerCollection = 3030,
  RoleConfigurationComponent = 3051,
  UserAssignmentComponent = 3056,
  UserConfigurationComponent = 3057,
  RoleDelegationConfigurationComponent = 7230,
  TriggerInfoComponent = 3500,
  TaskCreatorComponent = 5501,
  TaskRefElementViewerComponent = 3502,

  WellTestCOPComponent = 3503,
  TemplateExplorerComponent = 6013,
  FileUploadAdvancedComponent = 6328,

  AREA = 5030,
  CORPORATE = 5031,
  DIRECTORATE = 5032,
  OPERATIONAL_SUB_ASSET = 5033,
  OPERATIONAL_ASSET = 5034,
  CreamingCurveComponent = 5168,
  WELL_POTENTIAL = 5013,
  GascreamingcurveComponent = 5232,
  GISLatitudeGroup = 5433,
  GISLongitudeGroup = 5434,
  GISValueGroup = 5435,
  GISInput = 5432,
  GISNearByGroup = 5436,

  // TREND_XY = 5275,
  // TrendSeriesXYIndex = 5248,
  // TrendSeriesXYTimestamp = 5276,
  // TrendSeriesXY = 5249,
  // TrendSeriesX = 5250,
  // TrendSeriesY = 5251,
  // TREND_XY = 5275,
  // TrendSeriesXYIndex = 5248,
  // TrendSeriesXYTimestamp = 5276,
  // TrendSeriesXY = 5249,
  // TrendSeriesX = 5250,
  // TrendSeriesY = 5251,
  TrendSeriesXInput = 5252,
  TrendSeriesYInput = 5253,
  ColumnGroup = 5277,

  QuestionCollection = 6004,
  Question = 6005,
  AnswerCollection = 6006,
  Answer = 6007,

  Comment = 6015,
  TextEntry = 6016,
  Gps = 6017,

  DropdownList = 6024,

  Rating = 6227,
  PivotTable = 6229,

  ComplianceContainer = 6237,
  Choice = 6238,
  Label = 6240,
  SelectOptionComponent = 6267,
  MultiAdd = 6271,
  Signature = 6273,
  TriggerSource = 6286,
  WellTestControl = 6288,
  VisualControl = 6291,
  Test_Unit_Status = 6294,
  OpportunityVM = 6295,
  ClassifiedStatus = 6300,
  EBSBuilderComponent = 6280,
  Matrix_MTO = 6321,
  Matrix_Column = 6322,
  Matrix_Row = 6323,
  Matrix_Management = 6324,
  Form_User_Role = 6325,
  RankComponent = 6329,
  RankInput = 6330,
  ActionTrackerComponent = 6335,
  AdhocTrend = 6369,
  TextEditor = 6370,
  DisplayText = 6501,
  ReportCommunication = 6502,
  ReportDiagnostics = 6503,
  ReportModelStatus = 6504,
  ReportTable = 6505,
  CustomSummaryChartComponent = 6506,
  AttributeViewerSummaryCollection = 6507,
  DefermentAnalysisComponent = 6370,
  E2eReportComponent = 6371,
  PowerBIReport = 7110,
  ReportingTool = 7210,
  MoreInfoControlGroup = 7212,
  SchematicComponent = 7220,
  PatternConfigurationTool = 7320,
  WellOptimization = 7300,
  GroupedLineChart = 7234,
  RankMeComponent = 7323,
  PdfExport = 7507,
  TableChartSync = 7508,
  ChartSync = 7509,
  EditableAttributesGroup = 7550,
  TooltipAttributesGroup = 7551,

  // BSP Specific Uses (100000 - 199999)
}

export enum StaticUIComponent {
  NibrasTable = 1,
  NibrasChart = 2,
  DXManagerSidebar = 3,
  DXManagerExportConfigurationSidebar = 4,
  DXManagerImportConfigurationSidebar = 5
}

export enum WorkflowTemplates {
  TaskDashBoard = 5017,
  KPIComplianceDashboard = 5588
}

export enum UITemplates {
  Widget = 11017
}

//DO NOT DELETE THIS ENUM. Values for this will be filled from API.
export enum ElementTypes { }

export enum NFIdentity {
  //Empty = 0,
  Unknown = 0,
  Object = 1,
  DBNull = 2,
  Boolean = 3,
  Char = 4,
  SByte = 5,
  Byte = 6,
  Int16 = 7,
  UInt16 = 8,
  Int32 = 9,
  UInt32 = 10,
  Int64 = 11,
  UInt64 = 12,
  Single = 13,
  Double = 14,
  Decimal = 15,
  DateTime = 16,
  Guid = 17,
  String = 18,
  RDBMS_StoredProcedureQuery = 19,
  RDBMS_InlineQuery = 20,
  RDBMS_Adapter = 21,
  PI_Query = 22,
  PI_Adapter = 23,
  RDBMS_TimeSeriesQuery = 24,
  Formula_Query = 25,
  Formula_Adapter = 26,
  TagSet = 50,
  dcChartType = 27,
  dcChartSymbol = 63,
  dcChartMarkPoint = 64,
  dcColumnWidthStyle = 65,
  dcPivotAggregates = 66,
  dcProcessType = 45,
  dcProcessTrigger = 47,
  dcProcessViewerStatus = 91,
  dcProcessPriority = 46,
  dcPivotChartDataType = 67,
  dcConfigDropDownValues = 77,
  dcPivotChartType = 71,
  dcDateTimeOptions = 73,
  dcTextEntryTypes = 76,
  FormulaExpression = 78,
  XYPlotType = 68,
  LimitSettingsView = 95,
  TableType = 97,
  SortType = 98,
  dcDateTimeFrequency = 52,
  Element = 28,
  ElementTemplate = 29,
  Attribute = 30,
  AttributeTemplate = 31,
  BaseElementTemplate = 73,
  NotificationTemplate = 100,
  dcSLACompliance = 94,
  AttributeTemplates = 101,
  CollectiveMembers = 102,
  CategoriesAttribute = 103,
  SecurityIdentities = 104,
  SecurityIdentity = 105,
  SecurityMappings = 106,
  SecurityMapping = 107,
  CategoriesNotificationRule = 108,
  CategoryNotificationRule = 109,
  NotificationRuleTemplates = 110,
  NotificationRuleTemplate = 111,
  NotificationRules = 112,
  NotificationRule = 113,
  DeliveryFormats = 114,
  DeliveryFormat = 115,
  PICollectiveMembers = 116,
  PICollectiveMember = 117,
  PIServers = 118,
  PIServer = 119,
  TableConnections = 120,
  TableConnection = 121,
  Notifications = 122,
  Notification = 123,
  NotificationContacts = 124,
  NotificationContact = 125,
  NotificationContactTemplates = 126,
  NotificationContactTemplate = 127,
  NotificationContent = 129,
  PlugInsAnalysisRule = 130,
  PlugInAnalysisRule = 131,
  PlugInsTimeRule = 132,
  PlugInTimeRule = 133,
  PlugInsDataReference = 134,
  PlugInDataReference = 135,
  PlugInsDeliveryChannel = 136,
  Ports = 137,
  Port = 138,
  ReferenceTypes = 139,
  ReferenceType = 140,
  Results = 141,
  Result = 142,
  Tables = 143,
  Table = 144,
  TimeRules = 145,
  TimeRule = 146,
  CollectiveMember = 147,
  EventFrames = 148,
  EventFrame = 149,
  Systems = 150,
  System = 151,
  UOMs = 152,
  UOM = 153,
  UOMBaseClasses = 154,
  UOMBaseClass = 155,
  UOMClasses = 156,
  UOMClass = 157,
  Databases = 158,
  Database = 159,
  Adjustments = 160,
  Adjustment = 161,
  Analyses = 162,
  AnalysisRule = 165,
  AnalysisTemplates = 166,
  AnalysisTemplate = 167,
  AttributeList = 168,
  Attributes = 169,
  BaseElements = 170,
  BaseElement = 171,
  CategoriesAnalysis = 172,
  CategoryAnalysis = 173,
  CategoryAttribute = 174,
  CategoriesElement = 175,
  CategoryElement = 176,

  CategoriesReferenceType = 177,
  CategoryReferenceType = 178,
  CategoriesTable = 179,
  CategoryTable = 180,
  Connections = 181,
  Connection = 182,
  Elements = 183,
  ElementTemplates = 184,
  EnumerationSet = 185,
  EnumerationValue = 186,
  EnumerationSets = 187,
  Layers = 188,
  Layer = 189,
  Libraries = 190,
  Library = 191,
  NamedCollectionList = 192,
  Tag = 193,
  UOMDatabase = 194,
  Contact = 195,
  Query = 2000,
  Adapter = 2001,
  User = 2002,
  Role = 2003,
  FilterTag = 6290,
  InputParameterKeyPair = 2004,
  App = 2005,
  ProcessActivity = 2006,
  ProcessElement = 2007,
  ProcessDesign = 2008,
  ProcessDataContext = 6241,
  ProcessAction = 2094,
  InputParameterAttribute = 2009,
  TestType = 2010,
  Widget = 2011,
  Component = 2012,
  AppSetting = 2013,
  RoleElementHeader = 2014,
  Security_Identity = 2015,
  WELL = 5000,
  Hierarchy = 2017,
  TemplateHierarchy = 1501,
  ChildElementHierarchy = 1504,
  RuleHierarchy = 3003,
  AssetTemplate = 4000,
  ModelTemplate = 4002,
  ProcessTemplate = 4001,
  SchedulerJob = 2127,
  STREAM = 6000,

  //TagHierarchy = 119,
  //    TagElement = 120,
  //    TagAttribute = 121,
  //    TagElementTemplate = 122,
  //    TagAttributeTemplate = 123,
  //    TagCalculated = 124,
  //    TagApp = 125,
  //    TagWidget = 126,
  //    TagComponent = 127,

  ShallowSearch = 205,
  DeepSearch = 206,
  TagAll = 128,
  DIRECTORATE = 5032,
  AREA_NAME = 187,
  FIELD_NAME = 188,
  STATION_CODE = 189,
  OP_AREA_NAME = 190,
  WELL_NAME = 191,
  CONDUIT_NAME = 192,
  CORPORATE = 5031,
  OP_ASSET_NAME = 194,
  OP_SUB_ASSET_NAME = 195,
  AREA = 5030,
  OPERATIONAL_SUB_ASSET = 5033,
  OPERATIONAL_ASSET = 5034,
  OperatingEnvelope = 401,

  FormBuilderComponent = 2053,
  NFExplorerComponent = 2068,
  Position = 2077,
  ProcessApprovalComponent = 2080,
  ProcessBuilderComponent = 2081,
  ProcessViewerComponent = 2141,
  Report = 2086,
  RoleAssignment = 2091,
  Trend = 2112,
  TrendAxis = 2113,
  ControlGroup = 2114,
  TrendSeries = 2115,
  Trend_XAXIS_TIME = 2143,
  Trend_XAXIS_NONTIME = 2144,
  Trend_YAXIS_NUMERIC = 2145,
  Trend_YAXIS_NONNUMERIC = 2146,
  Trend_XAXIS = 2183,
  Trend_YAXIS = 2184,
  XAxisContainer = 6008,
  YAxisContainer = 6009,
  Resource_Staff = 267,
  NibrasSecurityIdentities = 269,
  ProcessTag = 272,
  RULE_HIERARCHY = 296,
  TaskViewerComponent = 2105,
  TextboxCollection = 2108,
  TextboxGroup = 2110,
  FormFilter = 300,

  ProcessSLA = 2082,
  ProcessTransition = 272,
  FormulaParserComponent = 2136,
  ScheduleBuilderComponent = 2151,
  ScheduleDesignComponent = 2149,
  DataFunction = 2036,
  ViolinPlot = 2147,
  ViolinPlotSeries = 2150,
  SankeyChart = 2148,
  SankeyChartGroups = 2152,
  SankeyChartFlow = 2153,
  WellTest = 2189,
  HierarchyBuilder = 2182,
  TREND_XY = 2198,
  TrendSeriesXY = 2199,
  TrendSeriesX = 2200,
  TrendSeriesY = 2201,
  TrendSeriesXYIndex = 2202,
  TrendSeriesXYTimestamp = 2203,
  TrendSeriesXConstant = 2204,
  TrendSeriesYConstant = 2205,
  AndonHighlevelDataInput = 2219,
  AndonHighlevelGroupByInput = 2220,
  AndonSubProcessDataInput = 2221,
  AndonSubProcessGroupByInput = 2222,
  AttributeViewer = 3032,
  AttributeViewerGroup = 3031,
  AttributeViewerCollection = 3030,
  HIERARCHY_RULE = 10775,
  UI_COMPONENT_HIERARCHY = 10781,
  CHILD_HIERARCHY = 10761,
  ElementTemplateSelfTag = 1500,
  ElementSelfTag = 1502,
  TemplateTagsToElement = 1503,
  ChildElementTemplateTagsToRootElement = 1505,
  CustomTags = 1506,
  ReadOnlyPermission = 1507,
  ReadWritePermission = 1508,
  MyProcess = 1509,
  MyProcessTemplates = 1510,
  MyProcessActivity = 1511,
  Optimize = 1512,
  Failure = 1513,
  Configuration = 1514,
  Design = 1515,
  RoleToHiearchyPermission = 1516,
  ProcessCategory = 1518,
  StandardHierarchy = 1603,
  OperationHierarchy = 1617,

  FileUploadComponent = 2191,
  FileUploadAdvancedComponent = 6328,

  UrlComponent = 2193,
  GisComponent = 2192,
  KPIConfiguration = 10076,
  KPIConfigurationType = 2190,
  GAS_CREAMING_CURVE = 5232,
  KPIAndonBoardComponent = 2216,
  LimitsSetings = 2196, //5148 // need to change 2196
  AdhocTrend = 6369,
  ALLOCATED_PRODUCTION_DAILY = 5150,
  ANALYSER_ONLINE = 5080,
  ANNULUS_PRESSURE = 5016,
  ANNULUS_PRESSURE_DOUBLE_CASING = 5023,
  ANNULUS_PRESSURE_QUAD_CASING = 5028,
  ANNULUS_PRESSURE_SINGLE_CASING = 5024,
  ANNULUS_PRESSURE_TRIPLE_CASING = 5026,
  APPLICATION = 5082,
  Analysis = 2020,
  AssetHierarchyRule = 2090,
  BASIC_ASSET = 5140,
  BLOWER = 5084,
  BSW = 5086,
  BT_BASIC_ASSET = 5155,
  BT_CONTROLLER = 5162,
  BT_NOC_2_PHASE = 5161,
  BT_SHUT_DOWN_VALVE = 5163,
  CASING_CEMENT = 5143,
  CASING_HEAD_PRESSURE = 5087,
  CASING_HEAD_TEMPERATURE = 5075,
  COLUMN = 5088,
  COLUMN_CAPACITY = 5089,
  COMPRESSOR = 5092,
  COMPRESSOR_CAPACITY = 5090,
  COMPRESSOR_DEVICE = 5091,
  CONCENTRATION_GAUGE = 5074,
  CONTROLLER = 5040,
  CONTROLLER_VALVE = 5095,
  CONTROL_VALVE = 5043,
  CORROSION_LOOP = 5015,
  CREAMING_CURVE = 5168,
  CUSTOM_ROLE_ASSIGNMENT = 6298,
  DATA_WELL_MANAGEMENT_BL = 5169,
  DATA_WELL_MANAGEMENT_ESP = 5151,
  DATA_WELL_MANAGEMENT_FF = 5153,
  DATA_WELL_MANAGEMENT_GL = 5159,
  DATA_WELL_MANAGEMENT_PCP = 5152,
  DCS = 5097,
  DEFERMENT = 5029,
  DHG = 5156,
  DHG_ESP = 5046,
  DHG_NON_ESP = 5141,
  DHG_PI = 5160,
  DPS = 5019,
  DPS_SENSOR = 5020,
  DPS_SENSORS = 5158,
  DTS = 5036,
  DeployBuilderComponent = 2129,
  DeployProcessComponent = 2140,
  ELEMENT = 5022,
  ENGINEERING_DATA = 5003,
  EQUIPMENT = 5018,
  EQUIPMENTS_SUB_SYSTEM_GROUP = 5110,
  EQUIPMENT_ALARMS = 5049,
  EQUIPMENT_DEVICE = 5064,
  EQUIPMENT_DRIVE = 5100,
  EQUIPMENT_GAS_TURBINE_DRIVE_DEVICE = 5101,
  EQUIPMENT_GEAR_BOX = 5102,
  EQUIPMENT_LUBE_OIL_SAMPLES = 5103,
  EQUIPMENT_MECHANICAL_SEAL_SYSTEM = 5104,
  EQUIPMENT_OIL_SYSTEM = 5105,
  EQUIPMENT_OIL_SYSTEM_DEVICE = 5106,
  EQUIPMENT_POWER_DATA = 5094,
  EQUIPMENT_PROCESS_FLUID_FILTER = 5116,
  EQUIPMENT_REFERENCE_DATA = 5071,
  EQUIPMENT_REFERENCE_DATA_MECHANICAL = 5070,
  EQUIPMENT_SHAFT = 5107,
  EQUIPMENT_SHAFT_END = 5108,
  EQUIPMENT_SUB_SYSTEM = 5109,
  ESD = 5048,
  ESP_MOTOR_CONTROLLER = 5007,
  ESTIMATE = 5001,
  FACILITY = 5035,
  FAP = 5004,
  FIELD = 5111,
  FLARING_SYSTEM = 5081,
  FLOW_LINE_PRESSURE = 5014,
  FLOW_LINE_TEMPERATURE = 5037,
  FLOW_METER = 5041,
  FLOW_METER_FLUID = 5060,
  FLUID_CONTACTS = 5061,
  GAS_BREAKTHROUGH_CONTROLLER = 5054,
  GAS_CAP_PRESSURE = 5062,
  GAS_LIFT_CONTROLLER = 5053,
  GAS_LIFT_HEADING = 5052,

  ISOLATOR = 6519,
  CONTROL_PANEL = 6518,
  CIRCUIT_BREAK = 6517,
  FIGURE = 6516,
  GENERATOR = 6515,
  DETECTOR = 6514,
  BATTERY_CHARGER = 6513,
  ELECTRIC_MOTOR = 6512,
  BATTERY = 6511,
  DAMPER = 6510,
  ALARM = 6509,
  SWITCHBOARD = 6508,
  TRANSFORMER = 6507,
  DISTRIBUTION_SYSTEM = 6506,
  SURFACE_SUB_OPERATION = 6505,
  SURFACE_OPERATION = 6504,
  PRODUCTION_UNIT = 6503,

  GISInput = 5432,
  GISLatitudeGroup = 5433,
  GISLongitudeGroup = 5434,
  GISValueGroup = 5435,
  GISNearByGroup = 5436,
  GISMapLegendGroup = 5437,

  HCA_DATA = 5025,
  HierarchyImportComponent = 2142,
  INTEGRITY_DATA = 5005,
  INVALID_WELL_TEST = 5006,
  IOW_PROCESS_DATA = 5096,
  LEVEL_GAUGE = 5112,
  LIMS_DATA = 5076,
  METERED_WELL_TEST = 5154,
  MOTOR_CONTROLLER = 5047,
  NOC_2_PHASE = 5017,
  NOC_DNOC = 5039,
  NOT_VALIDATED_WELL_TEST = 5008,
  NibrasFile = 2116,
  NibrasInput = 2195,
  OFM = 5009,
  OPC_SERVER = 5083,
  PATTERN = 3053,
  PATTERN_MEMBER = 3054,
  PCP_MOTOR_CONTROLLER = 5044,
  PERMISSION_READONLY = 2187,
  PERMISSION_READWRITE = 2188,
  PID_CONTROLLER = 5042,
  PRESSURE_CONTROLLER = 5113,
  PRESSURE_CONTROLLER_VALVE = 5115,
  PRESSURE_GAUGE = 5069,
  PRESSURE_GAUGE_SUB_SURFACE = 5085,
  PRESSURE_GAUGE_SURFACE = 5057,
  PUMP_CAPACITY = 5066,
  PUMP_CENTRIFUGAL = 5063,
  PUMP_CENTRIFUGAL_FSD = 5118,
  PUMP_CENTRIFUGAL_VSD = 5119,
  PUMP_DISCHARGE = 5120,
  PUMP_RECIPROCATING_FSD = 5121,
  PUMP_RECIPROCATING_VSD = 5122,
  PUMP_REFERENCE_DATA = 5124,
  PUMP_REFERENCE_DATA_GROUP = 5123,
  PUMP_REFERENCE_DATA_RPMS_GROUP = 5125,
  PUMP_SIDE = 5126,
  PUMP_SUCTION = 5127,
  ParametersBuilderComponent = 2139,
  Permission = 2137,
  ProcessDesignHierarchyRule = 2093,
  RB_BASE_STATION = 5170,
  RB_MARAC_MRC = 5171,
  RB_MARAC_MRC500 = 5172,
  RB_POINTRED = 5173,
  RB_SECTOR_CONTROLLER = 5174,
  RB_SUBSCRIBER = 5183,
  RD_BASE_STATION = 5184,
  RD_REDLINE_3000 = 5185,
  RD_REDLINE_3000_PMP_SECTOR_CONTROLLER = 5186,
  RD_REDLINE_3000_PMP_SUBSCRIBER = 5187,
  RD_REDLINE_3000_PTP_FAR = 5188,
  RD_REDLINE_3000_PTP_NEAR = 5189,
  RD_REDLINE_3000_PTP_SECTOR_CONTROLLER = 5190,
  RD_REDLINE_5000 = 5191,
  RD_REDLINE_5000_PTP_FAR = 5192,
  RD_REDLINE_5000_PTP_NEAR = 5193,
  RD_REDLINE_AN80I = 5194,
  RD_REDLINE_AN80I_PMP_SUBSCRIBER = 5195,
  RD_SECTOR_CONTROLLER = 5196,
  RD_SUBSCRIBER = 5197,
  RELIABILITY = 5073,
  REMOTE_TERMINAL_UNIT = 5129,
  RESERVOIR = 3052,
  RESULTS_WELL_TEST = 5135,
  ROD_PUMP_CONTROLLER = 5027,
  ROLES = 5077,
  ROLES_SURFACE_EQUIPMENTS = 5079,
  ROLE_ASSIGNEMENT = 2186,
  ROLE_ASSIGNMENT_GROUP = 2194,
  RPM_GAUGE = 5128,
  RTU_CAC6500 = 5198,
  RTU_DPS = 5201,
  RTU_EXS1000 = 5202,
  RTU_EXS1000_GLO = 5203,
  RTU_M2000 = 5206,
  RTU_MANIFOLD = 5209,
  RTU_PLC = 5212,
  RTU_PLC_HIMA = 5215,
  RTU_SAM_TCP = 5218,
  RTU_VMBUSIXC_2 = 5219,
  RTU_VMBUSX_C = 5222,
  RTU_VMBUSX_XP = 5223,
  RTU_VMBUSX_XP_GBC = 5226,
  RTU_WELL_PILOT = 5231,
  ReportColumn = 2087,
  RoleConfigurationComponent = 3051,
  RoleViewerComponent = 3050,
  RuleNode = 2128,
  SAMPLE_ANALYSIS = 5038,
  SAMPLING_POINT_FACILITY = 5130,
  SAMPLING_POINT_WELL_HEAD = 5078,
  SEPARATOR = 5131,
  SPEED = 5072,
  STEAM_INLET_PRESSURE = 5058,
  STEAM_INLET_TEMPERATURE = 5059,
  SchedulerService = 2126,
  TANK = 5132,
  TEMPERATURE_CONTROLLER = 5133,
  TEMPERATURE_GAUGE_SURFACE = 5067,
  TEMPERATURE_SENSOR = 5134,
  THERMAL_BREAKTHROUGH_CONTROLLER = 5056,
  TUBING_HEAD_PRESSURE = 5011,
  TUBING_HEAD_TEMPERATURE = 5021,
  //TUBING_HEAD_TEMPERATURE_SECOND = 5055,
  TagCategory = 2100,
  TaskCreator = 3501,
  TaskRefElementViewer = 3502,
  EBSBuilderComponent = 3504,
  TextboxComponent = 2109,
  TimeLine = 2111,
  TransitionBuilderComponent = 2138,
  TriggerInfo = 3500,
  UIComponentHiearchyRule = 2092,
  VALID_WELL_TEST = 5012,
  VIBRATION_GAUGE = 5099,
  VIBRATION_GAUGE_GROUP = 5098,
  VIBRATION_METER = 5065,
  WATER_INJECTION_CONTROLLER = 5157,
  WELLBORE_EQUIPMENT = 5145,
  WELL_DEVATION = 5146,
  WELL_EVENT = 5142,
  WELL_LITHOSTRAT = 5148,
  WELL_PCP_LIP = 5149,
  WELL_PERFORATION = 5147,
  WELL_PERFORMANCE_CONSTANTS = 5050,
  WELL_POTENTIAL = 5010,
  WELL_TYPE = 5136,
  WELL_WELLHEAD = 5144,
  WIMAX_BASE_STATION = 5137,
  WIMAX_GATEWAY = 5138,
  WIMAX_SUBSCRIBER = 5139,
  ColumnGroup = 5277,
  CONDITIONAL_FORMATTING = 2197,
  CONDITIONAL_FORMATTING_INPUT = 2195,
  BT_FILECATEGORY = 12003,
  PivotTable = 6229,
  GEOGRAPHICAL_AREA = 6233,
  COMPONENT_COMPLIANCE = 55988,
  Process_Category = 6263,
  Process_Category_Dev = 6254,
  MSV = 6243,
  TEST_DEVICE = 6248,
  Signature = 6273,
  PUMP = 6253,
  TriggerSource = 6286,
  TimeLineComponent = 2209,
  FormulaDR = 1197,
  Matrix_Data = 6321,
  Matrix_Column = 6322,
  Matrix_Row = 6323,
  Matrix_Management = 6324,
  RankComponent = 6329,
  RankInput = 6330,
  CorrosionLoop = 6281,
  DisplayText = 6501,
  ReportCommunication = 6502,
  ReportDiagnostics = 6503,
  ReportModelStatus = 6504,
  ReportTable = 6505,
  BT_ISOLATION_VALVE = 51445,
  SPECTACLE_BLIND = 51446,
  WELLHOLE = 6311,
  TrendSeriesZ = 6650,
  PROMOTED_ATTRIBUTE = 2097,
  WELL_CEMENT = 6885,
  ConstantGroup = 4003,
  WellOptimization = 7300,
  WellOptimizationOperatingParametersGroup = 7309,
  WellOptimizationOperatingParametersInput = 7310,
  WellOptimizationOperatingParametersRowsGroup = 7311,
  WellOptimizationOperatingParametersRowItem = 7312,
  WellOptimizationOperatingParametersCaseSelector = 7313,
  WellOptimizationOperatingParametersCaseSelectorInput = 7314,
  WellOptimizationOperatingParametersFilterGroup = 7315,
  WellOptimizationOperatingParametersFilterItem = 7319,
  WellOptimizationOperatingParametersFilterItemInitialValue = 7321,
  WellOptimizationOperatingParametersFilterItemFilterAttribute = 7322,
  EditableAttributesGroup = 7550,
  TooltipAttributesGroup = 7551,
  AnalysisDefaultMode = 333
}

/** Enumeration determines the mode for addelement slider */
export enum AddElementMode {
  New = 0,
  Child = 1
}

export enum DisplayMode {
  view = 0,
  edit = 1,
  create = 2,
  delete = 3
}

export enum DisplayAttributeMode {
  classic = 0,
  tile = 1,
  listview = 2,
  schematic = 3
}

export enum ProcessStatus {
  Planned = 0,
  Pending = 1,
  Completed = 2,
  Expired = 3,
  New = 4
}

export enum ProcessStatusText {
  Planned = ProcessStatus.Planned,
  'In Progress' = ProcessStatus.Pending,
  Completed = ProcessStatus.Completed,
  Expired = ProcessStatus.Expired,
  New = ProcessStatus.New
}

export enum dcSLALimit {
  TriggerTime = 1,
  ProcessTime = 2,
  RaiseSubprocess = 3,
  CompletionTime = 4
}

export enum ChartType {
  line = 0,
  bar = 1,
  StackedLine = 2,
  StackedArea = 3,
  StackedBar = 4,
  Violin = 5,
  scatter = 6,
  step = 7,
  multicolorLine = 8
}

export enum TrendAxisPosition {
  left,
  right,
  top,
  bottom
}

export type TrendAxisPositions = 'left' | 'right' | 'top' | 'bottom';
export const TrendAxisPositionMapping: Record<TrendAxisPosition, TrendAxisPositions> = {
  [TrendAxisPosition.left]: 'left',
  [TrendAxisPosition.right]: 'right',
  [TrendAxisPosition.top]: 'top',
  [TrendAxisPosition.bottom]: 'bottom'
};

export enum ChartIndicators {
  EMA = 1,
  SMA = 2
}

export enum ChartTrendLines {
  Linear = 1,
  Exponential = 2,
  Logarithmic = 3,
  Polynomial = 4,
  Power = 5,
  MA = 6
}

export enum ChartSymbol {
  none = 0,
  circle = 1,
  rect = 2,
  roundRect = 3,
  triangle = 4,
  diamond = 5,
  pin = 6,
  arrow = 7
}

export enum ChartMarkPoint {
  none = 0,
  min = 1,
  max = 2,
  both = 3
}

export enum XAxisPosition {
  top = 3,
  bottom = 4
}

export enum YAxisPosition {
  right = 1,
  left = 2
}

export enum XYPlotType {
  series = 1,
  point = 2,
  constant = 3,
  commaSeparatedValues = 4
}

export enum TextOrientation {
  left = 1,
  right = 2,
  center = 3
}

export enum ColumnWidthStyle {
  Pixels = 1,
  Percent = 2
  //None = 0
}

export enum SwitchToLatestData {
  Hide = 0, // N/A (Do not show Checkedbox)
  EnableChecked = 1, //Checked  by default
  EnableUnchecked = 2, //Unchecked  by default
  DisableChecked = 3 // Checked with disabled
}

export enum PivotAggregates {
  avg = 1,
  count = 2,
  first = 3,
  last = 4,
  max = 5,
  min = 6,
  sum = 7
}

export enum PivotChartDataType {
  category = 1,
  series = 2
}

export enum PivotChartType {
  groupedColumn = 1,
  stackedColumn = 2,
  normalizedColumn = 3,
  groupedBar = 4,
  stackedBar = 5,
  normalizedBar = 6,
  line = 7,
  scatter = 8,
  bubble = 9,
  pie = 10,
  doughnut = 11,
  area = 12,
  stackedArea = 13,
  normalizedArea = 14
}

export enum DateTimeFrequency {
  years = 0,
  months = 1,
  weeks = 2,
  days = 3,
  hours = 4,
  minutes = 5,
  seconds = 6
}

export enum YearMonthWeek {
  year = 0,
  month = 1,
  week = 2
}

export enum TextEntryTypes {
  Text = 1,
  TextArea = 2,
  Date = 3,
  DateTime = 4,
  Number = 5,
  RichText = 6
}

export enum DateTimeOptions {
  DateOnly = 1,
  DateTime = 2,
  DateTimeSeconds = 3
  //NoDate = 4
}

export enum ProcessTagTypes {
  ConfigureMail = 0,
  WorkflowProcess = 1,
  CreateTag = 2,
  AddScript = 3
}

export enum ProcessType {
  None = -1,
  FixRequest = 5244,
  InvestigationRequest = 5239,
  // OSW = 5238,
  // IntegratedAssurance = 5243,
  // IAPowerStation = 5242,
  FailureAlarm = 5240,
  OptimizationAlarm = 5241
  // MeetingTracker = 5245,
  // QRounds = 5248,
  // OSWAction = 5247,
  // IAAction = 5246,
  // InSourcingChecklist = 5249,
  // MEMaintenanceProductivity = 5280,
  // WellHandover = 5281,
  // DCSIPSChecklist = 5282
}

export enum ProcessTrigger {
  EBS = 1,
  AdHoc = 2,
  Planned = 3,
  Link = 5
}

export enum TransitionDisplayType {
  Always = 0,
  Once = 1,
  OnRepeat = 2
}

export enum ProcessViewerStatus {
  All = 1,
  Open = 2,
  Completed = 3
}

export enum ProcessActionTypes {
  ConfigureMail = 0,
  ConfigureProcess = 1,
  ConfigureTag = 2,
  ConfigureScript = 3
}

export enum ProcessDateFilterAppliesTo {
  ActivityCreated = 1,
  ActivityCleared = 2,
  ActivityProcessedOn = 3,
  ProcessCreated = 4,
  ProcessCleared = 5
}
export enum ProcessTitle {
  MyAction = 1,
  MyAssetAction = 2,
  MyRequest = 3
}

export enum WFScheduleTypes {
  Daily,
  Monthly,
  Weekly
}

export enum WorkflowDataReferenceValues {
  EmailConfig = 3,
  ProcessConfig = 0,
  TagConfig = 4
}

export enum ReportType {
  Daily = 1,
  Weekly = 2
}

export enum ConfigDropDownValues {
  Category = 1,
  Welltest = 2,
  Custom = 3,
  Process = 4
}

export enum WorkflowTemplateValues {
  ProcessConfiguration = 3420,
  EBSProcessConfiguration = 8625, //3427,
  //product version ID is 8670
  FormProcessConfiguration = 8670, // kpo 3436,
  //FormProcessConfiguration = 3436,
  BTProcessActivity = 5002,
  BTProcessTemplate = 5001,
  BTProcessSLA = 5032,
  FORMULA_QUERY = 22,
  INPUT_PARAM_ATTRIBUTE = 43,
  BT_DATAFUNCTIONS = 10000,
  TemplateAnalysis = 2020,
  EBSRule = 5501,
  ManualRule = 5502,
  TagAction = 5507,
  LinkAction = 5508,
  EmailAction = 5509,
  ProcessSLA = 5520,
  ActionTemplate = 6500
}

export enum CreamingCurveEnumTypes {
  'Gas Creaming Curve(FGOR)' = 1,
  'Gas Creaming Curve(TGLR)' = 2,
  'Water Creaming Curve' = 3,
  'Oil Creaming Curve' = 4,
  'Total Gas Creaming Curve(TGOR)' = 5
}

export enum GasCreamingCurveEnumTypes {
  'Gas Creaming Curve(TGLR)' = 1,
  'Water Creaming Curve' = 2,
  'Gas Creaming Curve(Dry Gas)' = 3,
  'Gas Creaming Curve(FGCR)' = 4,
  'Condensate Creaming Curve' = 5,
  'Total Gas Creaming Curve(TGCR)' = 6
}

export enum UOM {
  'm/s2' = 1,
  'cm/s2' = 2,
  'pH' = 3,
  'rad/s' = 4,
  'rpm' = 5,
  'ha' = 6,
  'cm2' = 7,
  'in2' = 8,
  'km2' = 9,
  'mm2' = 10,
  'acre' = 11,
  'mi2' = 12,
  'yd2' = 13,
  'm2' = 14,
  'ft2' = 15,
  'cSt' = 16,
  'mm2/s' = 17,
  'm3/kN' = 18,
  'mg/m3 (Conc)' = 19,
  'ng/m3 (Conc)' = 20,
  'mg/L (Conc.)' = 21,
  'g/m3 (Conc.)' = 22,
  'S/m' = 23,
  'uS/cm' = 24,
  'S/cm' = 25,
  'EUR' = 26,
  'USD' = 27,
  'bs' = 28,
  'ct' = 29,
  'mk' = 30,
  '£' = 31,
  'Zt' = 32,
  'byte' = 33,
  'KB' = 34,
  'MB' = 35,
  'GB' = 36,
  'TB' = 37,
  'p p m' = 38,
  'ug/L' = 39,
  'mg/m3' = 40,
  'g/cc' = 41,
  'g/cm3' = 42,
  'g/m3' = 43,
  'mg/L' = 44,
  'kg/m3' = 45,
  'g/L' = 46,
  'kg/L' = 47,
  'lb/bbl' = 48,
  'lb/ft3' = 49,
  'lb/US gal' = 50,
  't/m3' = 51,
  'P' = 52,
  'Pa*s' = 53,
  'mPa*s' = 54,
  'C' = 55,
  'Ah' = 56,
  'mA' = 57,
  'A' = 58,
  'V' = 59,
  'kV' = 60,
  'O' = 61,
  'MM Btu' = 62,
  'kcal' = 63,
  'MMcal' = 64,
  'Btu' = 65,
  'cal' = 66,
  'GJ' = 67,
  'kJ' = 68,
  'kWh' = 69,
  'MJ' = 70,
  'Ws' = 71,
  'J' = 72,
  'Wh' = 73,
  'MWh' = 74,
  'GWh' = 75,
  'J/K' = 76,
  'kJ/K' = 77,
  'Btu/°F' = 78,
  'Btu/°R' = 79,
  '%F/F' = 80,
  'FOE kg' = 81,
  'FOE lb' = 82,
  'FOE lton' = 83,
  'FOE t' = 84,
  'FOE ston' = 85,
  'FOE gal' = 86,
  'FOE bbl' = 87,
  'FOE-bbl' = 88,
  'FOE L' = 89,
  'k FOE-bbl' = 90,
  'FOE m3' = 91,
  'N' = 92,
  'dyne' = 93,
  'kgf' = 94,
  'lbf' = 95,
  'Hz' = 96,
  'counts/ml' = 97,
  'kcal/kg/°C' = 98,
  'kJ/kg/°C' = 99,
  'kcal/h/mm2/°C' = 100,
  'W/m2/K' = 101,
  'm' = 102,
  'cm' = 103,
  'in' = 104,
  'nmi' = 105,
  'km' = 106,
  'mm' = 107,
  'ft' = 108,
  'mi' = 109,
  'sxi' = 110,
  'yd' = 111,
  'microns' = 112,
  'FR' = 113,
  'cd' = 114,
  'kg' = 115,
  'g' = 116,
  'mg' = 117,
  'lb' = 118,
  't' = 119,
  'lton' = 120,
  'MM lb' = 121,
  'oz' = 122,
  'ston' = 123,
  'klb' = 124,
  'ton' = 125,
  'lton/d' = 126,
  'MMlb/d' = 127,
  'ston/d' = 128,
  'klb/d' = 129,
  'kg/s' = 130,
  'g/s' = 131,
  'lb/s' = 132,
  't/d' = 133,
  'kg/h' = 134,
  'kg/d' = 135,
  '%w/w' = 136,
  'kmol/hr' = 137,
  'gmol/s' = 138,
  'kmol/s' = 139,
  'lbmol/s' = 140,
  'mol/s' = 141,
  'mole%' = 142,
  'mole/mole' = 143,
  'ppm (Molar)' = 144,
  'Nm3/gmol' = 145,
  'Nm3/kmol' = 146,
  'Nft3/lbmol' = 147,
  'Ncf/lbmol' = 148,
  'NL/gmol' = 149,
  'sm3/kmol' = 150,
  'sft3/lbmol' = 151,
  'scf/lbmol' = 152,
  'sL/gmol' = 153,
  'sm3/gmol' = 154,
  'kg/mol' = 155,
  'g/gmol' = 156,
  'lb/lbmol' = 157,
  'kg/kmol' = 158,
  'g/mol' = 159,
  'gmol' = 160,
  'kmol' = 161,
  'lbmol' = 162,
  'mol' = 163,
  'mD' = 164,
  'Darcy' = 165,
  '°' = 166,
  'r' = 167,
  'rad' = 168,
  'Btu/h' = 169,
  'cal/s' = 170,
  'hp' = 171,
  'J/s' = 172,
  'kW' = 173,
  'MJ/h' = 174,
  'MMcal/h' = 175,
  'MM Btu/d' = 176,
  'MM Btu/h' = 177,
  'W' = 178,
  'MW' = 179,
  'GW' = 180,
  'mbar' = 181,
  'Pa' = 182,
  'atm' = 183,
  'bar' = 184,
  'inHg' = 185,
  'kgf/cm2' = 186,
  'kgf/m2' = 187,
  'kPa' = 188,
  'mmHg' = 189,
  'N/m2' = 190,
  'psi' = 191,
  'psia' = 192,
  'torr' = 193,
  'mPa' = 194,
  'Pa(g)' = 195,
  'atm(g)' = 196,
  'bar(g)' = 197,
  'inHg(g)' = 198,
  'kg/cm2(g)' = 199,
  'kg/m2(g)' = 200,
  'kPa(g)' = 201,
  'mbar(g)' = 202,
  'mmHg(g)' = 203,
  'N/m2(g)' = 204,
  'psig' = 205,
  'torr(g)' = 206,
  'kPa/m' = 207,
  'Cycles' = 208,
  'Strokes' = 209,
  'count' = 210,
  'rem/h' = 211,
  'Sv/h' = 212,
  'µSv/h' = 213,
  'mSv/h' = 214,
  'mrem/h' = 215,
  'Sv' = 216,
  'rem' = 217,
  'mrem' = 218,
  'µSv' = 219,
  'mSv' = 220,
  '(Sv)' = 221,
  'mg/kg' = 222,
  'm3/m3' = 223,
  '%' = 224,
  'Sm3/m3' = 225,
  'ppb' = 226,
  'ppm' = 227,
  'Siemen (S)' = 228,
  '(mS)' = 229,
  'uS' = 230,
  'MO' = 231,
  'kO' = 232,
  'ohms' = 233,
  'ohms/m' = 234,
  'J/g' = 235,
  'J/kg' = 236,
  'Btu/lb' = 237,
  'kcal/kg' = 238,
  'kJ/kg' = 239,
  'kJ/lb' = 240,
  'J/(kg K)' = 241,
  'kJ/(kg K)' = 242,
  'J/(g K)' = 243,
  'Btu/(lb °F)' = 244,
  'Btu/(lb °R)' = 245,
  'SG' = 246,
  'm3/kg' = 247,
  'cm3/g' = 248,
  'ft3/lb' = 249,
  'cm/s' = 250,
  'ft/s' = 251,
  'nmi/h' = 252,
  'km/h' = 253,
  'mi/h' = 254,
  'm/s' = 255,
  'mm/s' = 256,
  'Strokes/min' = 257,
  'N/m' = 258,
  'mgKOH/g' = 259,
  'K' = 260,
  '°F' = 261,
  '°C' = 262,
  '°R' = 263,
  'delta °F' = 264,
  'delta °R' = 265,
  'delta K' = 266,
  'delta °C' = 267,
  'd' = 268,
  'min' = 269,
  'ms' = 270,
  's' = 271,
  'h' = 272,
  'month' = 273,
  'week' = 274,
  'yr' = 275,
  'N.m' = 276,
  'ft lbf' = 277,
  'in lbf' = 278,
  'm kg' = 279,
  'UK gal' = 280,
  'MMm3' = 281,
  'US MMgal' = 282,
  'UK Mgal' = 283,
  'UK kgal' = 284,
  'acre ft' = 285,
  'Imp Mgal' = 286,
  'Imp kgal' = 287,
  'bbl' = 288,
  'Imp gal' = 289,
  'US Mgal' = 290,
  'US kgal' = 291,
  'cm3' = 292,
  'ft3' = 293,
  'kL' = 294,
  'L' = 295,
  'M L' = 296,
  'mL' = 297,
  'k m3' = 298,
  'US gal' = 299,
  'MMbbl' = 300,
  'kbbl' = 301,
  'm3' = 302,
  'Am3' = 303,
  'aft3' = 304,
  'acf' = 305,
  'MM aft3' = 306,
  'MM acf' = 307,
  'MMAm3' = 308,
  'M Am3' = 309,
  'k aft3' = 310,
  'k acf' = 311,
  'k Am3' = 312,
  'MNm3' = 313,
  'Nft3' = 314,
  'kNm3' = 315,
  'k Nm3' = 316,
  'Nm3' = 317,
  'sm3' = 318,
  'sft3' = 319,
  'MM scf' = 320,
  'scf' = 321,
  'k scf' = 322,
  'sm3/d' = 323,
  'm3/d' = 324,
  'MMm3/d' = 325,
  'sm3/h' = 326,
  'k m3/d' = 327,
  'm3/s' = 328,
  'bbl/d' = 329,
  'cm3/s' = 330,
  'ft3/s' = 331,
  'm3/h' = 332,
  'Imp gal/min' = 333,
  'L/s' = 334,
  'US gal/min' = 335,
  'MMSCMD' = 336,
  'k sm3/d' = 337,
  'l/day' = 338,
  'Am3/s' = 339,
  'aft3/s' = 340,
  'acf/s' = 341,
  'MM aft3/d' = 342,
  'MM acf/d' = 343,
  'MMAm3/d' = 344,
  'k aft3/h' = 345,
  'k acf/h' = 346,
  'k Am3/h' = 347,
  'MNm3/d' = 348,
  'Nft3/s' = 349,
  'Ncf/s' = 350,
  'kNm3/h' = 351,
  'Nm3/s' = 352,
  'sm3/s' = 353,
  'sft3/s' = 354,
  'MM sft3/d' = 355,
  'MM scf/d' = 356,
  'scf/s' = 357,
  'k sft3/h' = 358,
  'k scf/h' = 359,
  'sm3/s1' = 360,
  'M sm3/d' = 361,
  'MMsm3/d' = 362,
  'E3sm3/d' = 363,
  'Btu/bbl' = 364,
  'Btu/ft3' = 365,
  'kcal/m3' = 366,
  'J/m3' = 367,
  'J/sm3' = 368,
  'Btu/sft3' = 369,
  'Btu/scf' = 370,
  '%v/v' = 371,
  'kW/k' = 372,
  'k Sm3/h' = 373,
  'scf/bbl' = 376,
  'RB/d' = 377,
  'kVA' = 378,
  'fraction' = 380,
  'kbnd' = 382,
  '$/boe' = 383,
  'MMBND' = 384
}

export enum TagCategory {
  Unknown = 0,
  ElementTemplateSelfTag = 1500,
  TemplateHierarchy = 1501,
  ElementSelfTag = 1502,
  TemplateTagsToElement = 1503,
  ChildElementHiearchy = 1504,
  ChildElementTemplateTagsToRootElement = 1505,
  CustomTags = 1506,
  ReadOnlyPermission = 1507,
  ReadWritePermission = 1508,
  ReadWriteCategory = 100,
  ReadOnlyCategory = 101,
  MyProcess = 1509,
  MyProcessTemplates = 1510,
  MyProcessActivity = 1511,
  Optimize = 1512,

  Failure = 1513,
  Configuration = 1514,
  Design = 1515,
  RoleToHiearchyPermission = 1516,
  SkipProcessAction = 1525,
  TotalCompliance = 1526,
  NonCompliance = 1527,
  ExclusionNonCompliance = 1528,
  ExclusionCompliance = 1529
}

export enum HierarchyTagCategory {
  Standard = 1603,
  Operation = 1617,
  Basic = 1650,
  Geographical = 1651,
  Reservoir = 755,
  Asset = 1626
}

export enum TimeModeSelect {
  None = 0,
  CurrentTime = 1,
  SingleDate = 2,
  DateRange = 3,
  TimeRange = 4,
  SingleMonth = 5,
  SingleYear = 6,
  SingleDateTime = 7,
  AutoRange = 8
}
export enum CheckinDetailsEnum {
  CheckIn = 1,
  CheckOut = 2
}
export enum OverrideType {
  NoOverride = 0,
  TemplateOverride = 1,
  ElementOverride = 2,
  QueryParameterOverride = 3
}

export enum dcAttributeType {
  ProcessParameter = 4,
  External = 3,
  Refernce = 2,
  Asset = 1,
  DummyAttribute = 5
}
export enum dcActionFlag {
  NoChange = 0,
  Insert = 1,
  Update = 2,
  Delete = 3,
  DeleteHierarchy = 4,
  AddHierarchy = 5,
  HardDelete = 6
}

export enum GridsterItemTypes {
  Group = 0,
  TreeContainer = 1,
  LabelContainer = 2,
  QuestionContainer = 3,
  TextEditorContainer = 4
}

export enum ValidatorMessageTypes {
  Valid = 0,
  Invalid = 1,
  Exists = 2
}

export enum SignalRConnectionStatus {
  connected = 1,
  reconnecting = 2,
  disconnected = 4
}

export enum DatabaseTypes {
  SQL = 1,
  Oracle = 2
}

// export enum DataTransmissionMode2 {
//   Sync = 1,
//   Async = 2,
//   Consolidated = 3,
//   JSON = 4,
//   ConsolidatedAsync = 5
// }

export enum DataTransmissionMode {
  Sync = 1,
  Async = 2,
  Consolidated = 4,
  JSON = 8,
  ConsolidatedAsync = 16
}

export enum dcProcessPriority {
  High = 1,
  Medium = 2,
  Low = 3
}

export enum ProcessExecutionMode {
  Initiate = 1,
  InitiateWithParams = 2,
  Execute = 3
}

export enum TransitionClassifier {
  NotSpecified,
  Direct,
  Reverse
}

export enum NibrasClient {
  Web = 1,
  Mobile = 2,
  WebMobile = 3,
  Scheduler = 4
}

// export enum SeriesColor {
//   yellow = 1,
//   green = 2,
//   red = 3,
//   gray = 4
// }

export enum dcSLACompliance {
  Completed = 1,
  OnTime = 2,
  Expired = 3,
  Delayed = 4,
  Skipped = 5
}

export enum dcProcessType {
  FixRequest = 5244,
  InvestigationRequest = 5239,
  OSW = 5238,
  IntegratedAssurance = 5243,
  IAPowerStation = 5242,
  FailureAlarm = 5240,
  OptimizationAlarm = 5241,
  MeetingTracker = 5245,
  QRounds = 5248,
  OSWAction = 5247,
  IAAction = 5246,
  InSourcingChecklist = 5249,
  MEMaintenanceProductivity = 5280,
  WellHandover = 5281,
  DCSIPSChecklist = 5282
}

export enum SchedulerType {
  Onetime = 'OneTime',
  Recurring = 'Recurring'
}

export enum SchedulerFrequencyType {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly'
}

export enum SchedulerDailyFrequencyType {
  Onetime = 'OneTime',
  Recurring = 'Recurring'
}

export enum SchedulerDailyFrequencyIntervalType {
  Hours = 'Hours',
  Minutes = 'Minutes'
}

export enum SchedulerMonthlyConfigType {
  Day = 'Day',
  Date = 'Date'
}

export enum SchedulerEndType {
  NoEndDate = 'No End Date',
  EndAfter = 'End after',
  EndBy = 'End by'
}

export enum WeekDays {
  Sunday = 1,
  Monday = 2,
  Tuesday = 3,
  Wednesday = 4,
  Thursday = 5,
  Friday = 6,
  Saturday = 7
}

export enum DayInAlpha {
  First = 'First',
  Second = 'Second',
  Third = 'Third',
  Fourth = 'Fourth',
  Fifth = 'Fifth'
}

export enum SchedulerServiceID {
  DefaultStateMachineProcessID = 1,
  DefaultSequentialProcessID = 2,
  DefaultProcessIdForMobileEnabled = 3
}

export enum dcLookupDataMethod {
  AllValues = 0, //Get all the values
  WildCard = 1, //like search or contains operation
  WhereCondition = 2 //multiple where conditions for cascaded dropdown operations
}

export enum QueryOperation {
  READ = 1,
  WRITE = 2,
  PERSISTENTREAD = 3,
  PERSISTENTWRITE = 4,
  WRITETOSOURCE = 5,
  LOOKUP = 6
}

export enum TIME_FORMAT {
  Date = 1,
  DateTime = 2
}

export enum Frequency_Format {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Yearly = 4
}

export enum FrequencyText {
  days = 1,
  weeks = 2,
  months = 3,
  years = 4,
  minutes = 5,
  hours = 6
}

export enum SAPConsequenceCategory {
  'A' = 'Asset Damage/Deferement',
  'E' = 'Environment',
  'P' = 'People',
  'R' = 'Reputation'
}

export enum SAPConsequenceSeverity {
  'Slight impact' = 1,
  'Minor impact' = 2,
  'New Request' = 3,
  'Major impact' = 4,
  'Massive impact' = 5
}

export enum SAPLikelihood {
  'A' = 'Unlikely to occur within 12 months',
  'B' = 'Likely to occur 3 months - 12 months',
  'C' = 'Likely to occur 2 weeks - 3 months',
  'D' = 'Likely to occur 2 days - 2 weeks',
  'E' = 'Likely to occur within 1-2 days/occuring now'
}

export enum SAPSCN {
  'operational' = 1,
  'in limited operation' = 2,
  'New Request' = 3
}

export enum TableType {
  Normal = 1,
  TopList = 2
}

export enum SortType {
  Asc = 1,
  Desc = 2
}

export enum LineType {
  solid = 0,
  dashed = 1,
  dotted = 2
}
export type LineTypes = 'solid' | 'dashed' | 'dotted';
export const LineTypeMapping: Record<LineType, LineTypes> = {
  [LineType.solid]: 'solid',
  [LineType.dashed]: 'dashed',
  [LineType.dotted]: 'dotted'
};

export enum MatrixSearchType {
  'Company No' = 1,
  'Role' = 2,
  'Reference Indicator' = 3,
  'Email' = 4,
  'Full Name' = 5
}

export enum HTMLElementType {
  button = 1,
  select = 2,
  dropdown = 3,
  checkbox = 4,
  sopViewerButton = 5,
  numericInput = 6, // TODO need to check this conflict and reorder number. PU it was 5.
  customTemplate = 7,
  splitButton = 8
}

export enum RowEditPin {
  Left = 1,
  Right = 2
}

export enum ShowInColumnGroup {
  Open = 1,
  Close = 2,
  Always = 3
}

export enum ColumnGroupStatus {
  Open = 'open',
  Close = 'closed'
}

export enum LimitDiagramFiles {
  DailyFileID = 23209,
  MonthlyFileID = 23200
}

export enum ViewTypes {
  none = 'none',
  basic = 'basic',
  advanced = 'advanced',
  list = 'List',
  grid = 'Grid'
}

export enum DataFrequency {
  Day = '1D',
  Month = '30d',
  Year = '1Y',
  Hour = '1H',
  Minute = '1m'
}

export const DataFrequencyMap = new Map<number, string>([
  [0, DataFrequency.Day],
  [1, DataFrequency.Month],
  [2, DataFrequency.Year],
  [3, DataFrequency.Hour],
  [4, DataFrequency.Minute]
]);

export enum SearchQueryFilter {
  Contains = 'Contains',
  EqualTo = 'EqualTo',
  StartWith = 'StartWith',
  EndsWith = 'EndsWith'
}

export enum SortDirection {
  NoSort = 0,
  SortAsc = 1,
  SortDesc = 2
}

export enum PrintCommands {
  None = 1,
  ExportProcess = 2
}

export enum VMComplianceDetails {
  EvacuationProcessName = 'OSW Site-Evacuation Drill'
}

export enum AnnotationAction {
  Refresh = 'Refresh',
  AddObservation = 'Add Observation',
  Export = 'Export to excel'
}
export enum Alignment {
  Vertical = 0,
  Horizontal = 1
}
export enum LogSeverityColor {
  Critical = 1,
  Error = 2,
  Warning = 4,
  Information = 8,
  Debug = 16
}

export enum AttributeType {
  NxAttribute = 1,
  PiAttribute = 2
}

export enum CustomMapImage {
  CustomMap = 'CustomMap',
  ACTUAL_STATUS = 'ACTUAL_STATUS',
  CONDUIT_TYPE = 'CONDUIT_TYPE',
  PLATFORM_NAME = 'PLATFORM_NAME',
  FLOW_LINE_OUTPUT = 'FLOW_LINE_OUTPUT',
  FLOW_LINE_PORT = 'FLOW_LINE_PORT_1',
  CStart_ConduitName = 'CStart_ConduitName',
  CEnd_ConduitName = 'CEnd_ConduitName',
  WELL_PORNET = 'WELL_PORNET',
  WELL_NTG = 'WELL_NTG'
}

export enum CustomAttributeTemplate {
  WellName = 'CONDUIT_NAME_CD',
  Sand = 'SAND',
  ECWellStatus = 'EC_WELL_STATUS',
  Zone = 'ZONE',
  Block = 'BLOCK',
  Platform = 'PLATFORM_NAME',
  ZoneStatus = 'ZONE_STATUS',
  PerfThickness = 'PERF_THICKNESS',
  WellProdMethod = 'WELL_PROD_METHOD',
  ZoneStartDate = 'ZONE_START_DATE',
  BSW = 'BSW',
  ECWellStatusDisplay = 'EC_WELL_STATUS_DISPLAY',
  YCoordinates = 'YCoordinates',
  XCoordinates = 'XCoordinates'
}

export enum SummaryOptions {
  None = 0,
  Average = 1,
  Sum = 2,
  Min = 3,
  Max = 4,
  Count = 5
}

export enum ConvertUnits {
  MinsToDays = 'minsTodays',
  DaysToMins = 'daysTomins'
}

export enum PowerBIType {
  Report = 0,
  Dashboard = 1
}

export enum FormInputProperties {
  Value = 'value',
  IsGoodValue = 'isgood',
  ValueSet = 'valueset',
  Visibility = 'visibility',
  Disabled = 'disabled',
  Required = 'required',
  SuggestedValue = 'suggestedvalue',
  Iscompliant = 'iscompliant'
}

export enum SchematicColumns {
  Casing_Type = 0,
  Casing_Size = 1,
  Bottom_Depth_TBF = 2,
  Top_Depth_TBF = 3,
  Cement_Type = 4,
  Cement_Size = 5,
  Top_AHD_TBF = 6,
  Base_AHD_TBF = 7,
  Deviation_MD = 8,
  Deviation_X = 9,
  Deviation_Y = 10,
  CompDetail = 11,
  Comp_Group = 12,
  Depth_Top_AHD_TBF = 13,
  MinID = 14,
  Nom_Size = 15,
  Gun_Size = 16,
  Prod_INT_Bottom_TVDSS = 17,
  Prod_INT_Top_TVDSS = 18,
  Comp_Size = 19,
  Distance = 20
}

export enum GeoAnalyticsChartType {
  SchematicComponent = 0,
  WellLogs = 1,
  ReservoirMap = 2
}

export enum PDFOutputType {
  Default = 'save',
  ArrayBuffer = 'arraybuffer',
  Blob = 'blob',
  Bloburl = 'bloburl',
  Bloburi = 'bloburi'
}

export enum StickPlotsGraph {
  WellNames = '|FluidContact|ConduitName',
  Sands = '|FluidContact|Mores_Surface',
  TVDSS = '|FluidContact|TVDSS',
  Fluid_String = '|FluidContact|Fluid_String'
}

export enum ReportNavigationMode {
  Slider = 1,
  DockAsApp = 2
}

export enum AnalysisDefaultMode {
  Sankey = 1,
  Historical = 2,
  Pareto = 3
}

export enum ProcessLinkActionType {
  UPDATE = 1,
  CREATE = 2,
  DELETE = 3,
  UNLINK = 4
}
